import { getAll } from "./commonRequests";

const TAXPAYERTYPE_PATH = "/taxpayer_type";

export const getAllTaxpayerTypes = () => {
  return getAll(TAXPAYERTYPE_PATH);
};
